import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { TableGenericComponent } from '../../../custom/table-generic/table-generic.component';

import { AppComponentGenericComponent } from '../../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../../services/data.service';

import { GenericFilterParameter } from '../../../../models/generic-comunication-cmp';
import { GenericExternalCommandType } from '../../../../models/generic-external-command';
import { OperatoriTableField } from '../../../../models/library-table-field';
import { GenericTableField } from '../../../../models/generic-table-field';
import { User } from '../../../../models/user';

@Component({
  selector: 'app-operatori-permessi',
  templateUrl: './operatori-permessi.component.html',
  styleUrls: ['./operatori-permessi.component.css']
})
export class OperatoriPermessiComponent extends AppComponentGenericComponent implements OnInit {
    @Output() operatorEmitter = new EventEmitter();
    // Sync
    operatori: User[] = [];
    operatoriSync: Subscription;

    // FilterBox
    parametriString: string = "{}";
    parametri: GenericFilterParameter = null;
    externCommands: Map<string, GenericExternalCommandType> = null;

    // Table
    tableFields: OperatoriTableField;
    headerFields: GenericTableField[];
    operatoriFiltered: User[] = [];
    footerFields: GenericTableField[];
    ngClassRow = "";

    // Modal
    modalInput: any;

    constructor(protected dataService: DataService){
        super(dataService, 'operatori-permessi');
    }

    ngOnInit() {
        this.tableFields = new OperatoriTableField();
        this.headerFields = this.tableFields.getHeader();
        this.footerFields = this.tableFields.getFooter();

        this.parametri = new GenericFilterParameter();
        this.parametri.setDettaglioView(Boolean(false));
        this.parametri.setTypeFilter("gestione-utenti");
        this.parametri.setTitleBox("Operatori");
        this.parametri.setNumFilteredTxt("Operatori");
        this.updateParametri();

        this.operatoriSync = this.dataService.getComuniService().operatori$.subscribe(
          operatori => {
            this.operatori = operatori;
            console.log("CMP|OPERATORI-PERMESSI - OPERATORI:", this.operatori);
                    this.parametri.setDataArraySource(this.operatori);
                    this.updateParametri();
          });
    }

    apriModifica(user: User){
        let eventObject = {
            "type": "apriModifica",
            "data": user
        };
        console.log('eventObject', eventObject);
        this.operatorEmitter.emit(eventObject);
    }

    apriNuovo(){
        /*let person = new Person();
        //person.anagrafica_id = 'new';
        console.log('anagrafica new person', person, this.writePermission);
        this.personSelected = person;
        this.parametri.setDettaglioView(Boolean(this.personSelected));
        this.updateParametri();
        this.changeState();*/
    }

    exportCsv() {
        let filename = "operatori";
        let data = [];
        /*for (let operatore of this.operatoriFiltered) {
            let item = {}
            item['ID'] = operatore.operatore_id;
            item['Codice Fiscale'] = operatore.codice_fiscale;
            item['Cognome'] = operatore.cognome;
            item['Nome'] = operatore.nome ? operatore.nome : "";
            item['Indirizzo'] = operatore.indirizzo_completo ? operatore.indirizzo_completo : "";
            item['Comune'] = operatore.comune ? operatore.comune : "";
            item['Provincia'] = operatore.prov ? operatore.prov : "";
            item['CAP'] = operatore.cap ? operatore.cap : "";
            item['Email'] = operatore.email ? operatore.email : "";
            item['Telefono'] = operatore.telefono ? operatore.telefono : "";
            item['Comune Nascita'] = operatore.nascita_comune ? operatore.nascita_comune : "";
            item['Provincia Nascita'] = operatore.nascita_prov ? operatore.nascita_prov : "";
            item['Data Nascita'] = operatore.nascita_data ? operatore.nascita_data : "";
            item['Data Decesso'] = operatore.decesso_data ? operatore.decesso_data : "";
            item['Aggiornato'] = operatore.aggiornamento_data_ridotta_view ? operatore.aggiornamento_data_ridotta_view : "";
            data.push(item);
        }
        this.dataService.exportCsv(filename,data);*/
    }

    updateParametri(){
        //console.log('CMP|OPERATORI-PERMESSI - CHANGE UPDATEPARAMETRI', this.parametri);
        this.parametriString = this.parametri.generateParametriToString();
        //console.log('CMP|OPERATORI-PERMESSI - CHANGE UPDATEPARAMETRISTRING', this.parametriString);
    }

    manageEventFilterBox($event){
		//console.log("manageEventFilterBox", $event);
		if($event){
			switch($event.type){
			case 'filterResult':
				this.operatoriFiltered = ($event.data) ? $event.data : [];
				//console.log("CMP|OPERATORI-PERMESSI - operatoriFiltered", this.operatoriFiltered);
				this.tableFields.generateFooterRow();
				this.footerFields = this.tableFields.getFooter();
				break;
			case 'action':
				let dataCommand = $event.data;
				let codeCommand = dataCommand.code;
				let typeCommand = dataCommand.type;
				let textCommand = dataCommand.text;
				switch(typeCommand) {
				case 'add':
					this.apriNuovo();
					break;
				case 'esporta-operatori':
					this.exportCsv();
					break;
				}
				//console.log("operatori action", this.modalInput);
				//if (codeCommand.length) {
				//	this.mw.show(codeCommand, this.modalInput);
				//}
				break;
			default:
				console.log("type non riconosciuto!");
			}
		}
    }

    ngOnDestroy() {
		this.operatoriSync.unsubscribe();
    }
}
